/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Product_CrossfitInputs */

const fr_membership_plan_change_product_crossfit = /** @type {(inputs: Membership_Plan_Change_Product_CrossfitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crossfit`)
};

/**

* @param {Membership_Plan_Change_Product_CrossfitInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_product_crossfit = /** @type {((inputs?: Membership_Plan_Change_Product_CrossfitInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Product_CrossfitInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_product_crossfit(inputs)
});